import { BillLineItemV2Kind, BillLineDebitFineV2 } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemDebitFineMock = new MockFactory<BillLineDebitFineV2>({
  id: 'line_item_id_02',
  amount_cents: 20000,
  reference_date: '2023-12-01T00:00:00Z',
  payer_id: 'player_id_01',
  kind: BillLineItemV2Kind.DebtFine,
  metadata: {
    fine_debt_id: 'fine_debt_id_1',
    base_debt_id: 'base_debt_it_1',
    total_amount_cents: 2000,
    paid_amount_cents: 0,
    created_at: '2022-04-11T00:00:00Z',
    activated_at: '2022-04-10T00:00:00Z',
    fine_kind: 'fine_kind_1',
    fine_rate: 300,
    due_at: '2022-04-10T00:00:00Z',
    purchase_debt_amount: 1000,
    purchase_debt_due_at: '2023-10-30T23:59:59-00:00',
  },
})
